
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { Suspense } from 'react';

// Lazy load pages with prefetch hints
const HomePage = lazy(() => import("../pages/home/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const RoomsPage = lazy(() => import("../pages/rooms/page"));
const ExperiencesPage = lazy(() => import("../pages/experiences/page"));
const ThingsToDoPage = lazy(() => import("../pages/things-to-do/page"));
const MoshiGuidePage = lazy(() => import("../pages/moshi-guide/page"));
const BlogPage = lazy(() => import("../pages/blog/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const TrekPlannerPage = lazy(() => import("../pages/trek-planner/page"));
const ResourcesPage = lazy(() => import("../pages/resources/page"));
const PressKitPage = lazy(() => import("../pages/press-kit/page"));
const PartnersPage = lazy(() => import("../pages/partners/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

// Blog posts - lazy load on demand
const KilimanjaroGuide = lazy(() => import('../pages/blog/posts/kilimanjaro-guide'));
const BestTimeToVisit = lazy(() => import('../pages/blog/posts/best-time-to-visit-kilimanjaro'));
const RoutesComparison = lazy(() => import('../pages/blog/posts/kilimanjaro-routes-comparison'));
const PackingList = lazy(() => import('../pages/blog/posts/kilimanjaro-packing-list'));
const AltitudeSickness = lazy(() => import('../pages/blog/posts/kilimanjaro-altitude-sickness'));
const CostGuide = lazy(() => import('../pages/blog/posts/kilimanjaro-cost-guide'));
const TrainingGuide = lazy(() => import('../pages/blog/posts/kilimanjaro-training-guide'));

// Legal pages
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsConditionsPage = lazy(() => import('../pages/terms-conditions/page'));

// Optimized loading spinner
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#A67C52]"></div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Suspense fallback={<LoadingSpinner />}><HomePage /></Suspense>,
  },
  {
    path: '/rooms',
    element: <Suspense fallback={<LoadingSpinner />}><RoomsPage /></Suspense>,
  },
  {
    path: '/experiences',
    element: <Suspense fallback={<LoadingSpinner />}><ExperiencesPage /></Suspense>,
  },
  {
    path: '/blog',
    element: <Suspense fallback={<LoadingSpinner />}><BlogPage /></Suspense>,
  },
  {
    path: '/blog/kilimanjaro-trekking-guide',
    element: <Suspense fallback={<LoadingSpinner />}><KilimanjaroGuide /></Suspense>,
  },
  {
    path: '/blog/best-time-to-visit-kilimanjaro',
    element: <Suspense fallback={<LoadingSpinner />}><BestTimeToVisit /></Suspense>,
  },
  {
    path: '/blog/kilimanjaro-routes-comparison',
    element: <Suspense fallback={<LoadingSpinner />}><RoutesComparison /></Suspense>,
  },
  {
    path: '/blog/kilimanjaro-packing-list',
    element: <Suspense fallback={<LoadingSpinner />}><PackingList /></Suspense>,
  },
  {
    path: '/blog/kilimanjaro-altitude-sickness',
    element: <Suspense fallback={<LoadingSpinner />}><AltitudeSickness /></Suspense>,
  },
  {
    path: '/blog/kilimanjaro-cost-guide',
    element: <Suspense fallback={<LoadingSpinner />}><CostGuide /></Suspense>,
  },
  {
    path: '/blog/kilimanjaro-training-guide',
    element: <Suspense fallback={<LoadingSpinner />}><TrainingGuide /></Suspense>,
  },
  {
    path: '/about',
    element: <Suspense fallback={<LoadingSpinner />}><AboutPage /></Suspense>,
  },
  {
    path: '/contact',
    element: <Suspense fallback={<LoadingSpinner />}><ContactPage /></Suspense>,
  },
  {
    path: '/moshi-guide',
    element: <Suspense fallback={<LoadingSpinner />}><MoshiGuidePage /></Suspense>,
  },
  {
    path: '/things-to-do',
    element: <Suspense fallback={<LoadingSpinner />}><ThingsToDoPage /></Suspense>,
  },
  {
    path: '/trek-planner',
    element: <Suspense fallback={<LoadingSpinner />}><TrekPlannerPage /></Suspense>,
  },
  {
    path: '/resources',
    element: <Suspense fallback={<LoadingSpinner />}><ResourcesPage /></Suspense>,
  },
  {
    path: '/press-kit',
    element: <Suspense fallback={<LoadingSpinner />}><PressKitPage /></Suspense>,
  },
  {
    path: '/partners',
    element: <Suspense fallback={<LoadingSpinner />}><PartnersPage /></Suspense>,
  },
  {
    path: '/privacy-policy',
    element: <Suspense fallback={<LoadingSpinner />}><PrivacyPolicyPage /></Suspense>,
  },
  {
    path: '/terms-conditions',
    element: <Suspense fallback={<LoadingSpinner />}><TermsConditionsPage /></Suspense>,
  },
  {
    path: '*',
    element: <Suspense fallback={<LoadingSpinner />}><NotFound /></Suspense>,
  },
];

export default routes;
